import {
  Box,
  Button,
  Grid,
  IconButton,
  styled,
  Typography,
} from "@mui/material";
import { useQueryClient } from "react-query";
import { photoFetchStatusState, fotoProfileUrlState } from "../../../recoil/UserFotoProfileState";
import { fileFotoKey } from "../../../api/effects/queries/DataPribadi/useFetchFotoProfile";
import useFetchFotoProfile from "../../../api/effects/queries/DataPribadi/useFetchFotoProfile";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import React, { useEffect, useState } from "react";
import ProfileState from "../../../recoil/ProfileState";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import UserState from "../../../recoil/UserState";
import { eraseCookie, getCookie } from "../../../utils/cookies";
import { useNavigate } from "react-router-dom";
import { useAddFotoProfile } from "../../../api/effects/mutations/DataPribadi/addFotoProfile";
import { WarningModal } from "../../../components/WarningModal";
import { InputFileModal } from "../../../components/InputFileModal";
import AppliedJobTable from "./AppliedJobTable";
import { GridSkeleton, SkeletonTable, SkeletonText } from "../ProfileTabPage";
import { setProfilePhotoInStorage } from "../../../utils/photoStorage";

const RootGrid = styled(Grid)(({ theme }) => ({
  height: "100%",
}));

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "90%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  maxHeight: "60vh",
  [theme.breakpoints.down("md")]: {
    width: "60%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "80%",
    padding: "10px",
  },
  margin: "1%",
}));

const TextTitle = styled(Typography)(({ theme }) => ({
  paddingTop: "2vh",
  paddingLeft: "4vw",
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "12vw",
  },
}));

const ButtonFull = styled(Button)({
  padding: "10px",
  width: "100%",
  justifyContent: "flex-start",
});

type Props = { handleTab: (newValue: number) => void };

export default function ProfilePageOld({ handleTab }: Props) {
  const recoilValue = useRecoilValue(ProfileState);
  const recoilValueUser = useRecoilValue(UserState);
  const removeRecoil = useResetRecoilState(UserState);
  const token = getCookie("token");
  const queryClient = useQueryClient();
  const setPhotoFetchStatus = useSetRecoilState(photoFetchStatusState);
  const setFotoProfileUrl = useSetRecoilState(fotoProfileUrlState);
  const recoilValueFotoProfile = useRecoilValue(fotoProfileUrlState);
  const navigate = useNavigate();

  useFetchFotoProfile();

  const eraseAuthCookie = async () => {
    removeRecoil();
    eraseCookie("token");
  };

  const handleChangePasswordButton = () => {
    navigate("/ChangePassword");
  };

  const handleLogoutButton = () => {
    eraseAuthCookie().then(() => navigate("/Login", { replace: true }));
  };

  const [fileModal, setFileModal] = useState(false);
  const [warningModalState, setWarningModalState] = useState(false);
  const [warningModalText, setWarningModalText] = useState("");
  const { mutate: addFotoMutation, isLoading: isUploading } = useAddFotoProfile();

  const handleSavePhoto = async (file: File) => {
    addFotoMutation(file, {
      onSuccess: async () => {
        const arrayBuffer = await file.arrayBuffer();
        const dataUrl = setProfilePhotoInStorage(arrayBuffer);
        setFotoProfileUrl(dataUrl);
        setPhotoFetchStatus('success');
        queryClient.invalidateQueries([fileFotoKey]);

        setWarningModalText("Foto Profile Uploaded");
        setWarningModalState(true);
        setFileModal(false);
      },
      onError: () => {
        setWarningModalText("Error Uploading Foto Profile ");
        setWarningModalState(true);
      },
    });
  };

  const handleOpenFileModal = () => {
    recoilValue?.Data === false ? handleTab(1) : setFileModal(true);
  };

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <GridSkeleton justifyContent="center" alignItems="center">
        <SkeletonText variant="text" />
        <SkeletonTable variant="rectangular" />
      </GridSkeleton>
    );
  }

  return (
    <Box>
      <WarningModal
        open={warningModalState}
        handleClose={() => {
          setWarningModalState(false);
        }}
        text={warningModalText}
      />
      <InputFileModal
        open={fileModal}
        uploaded={!!recoilValueFotoProfile}
        handleClose={() => setFileModal(false)}
        handleSave={handleSavePhoto}
        inputAccept={".jpg, .jpeg, .png"}
        text="Foto"
        isLoading={isUploading}
      />

      <RootGrid
        container
        justifyContent="center"
        alignItems="center"
        direction="row"
      >
        <Grid container justifyContent="flex-start" item sm={10}>
          <TextTitle variant="h5">Account</TextTitle>
          <Grid container justifyContent="center">
            <SquareGrid container>
              <Grid
                container
                justifyContent="flex-start"
                alignContent="center"
                alignItems="center"
                item
                sm={12}
                md={6}
              >
                <Typography variant="h6">Email : </Typography>
                <Typography>&nbsp;{recoilValueUser?.EMAIL} </Typography>
              </Grid>
              <Grid container justifyContent="flex-end" item sm={12} md={6}>
                <IconButton
                  sx={{ mx: { xs: "auto", md: 0 }, mr: { md: 2 }, color: "black" }}
                  size="large"
                  edge="start"
                  aria-label="menu"
                  onClick={handleOpenFileModal}
                >
                  {recoilValueFotoProfile ? (
                    <Box
                      component="img"
                      src={recoilValueFotoProfile}
                      sx={{
                        height: "16vh",
                        width: "16vh",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "90px",
                      }}
                    />
                  ) : (
                    <AccountCircleIcon
                      color="error"
                      sx={{ height: "16vh", width: "auto" }}
                    />
                  )}
                </IconButton>
              </Grid>
            </SquareGrid>
          </Grid>
        </Grid>
        <Grid container justifyContent="flex-start" item sm={10}>
          <TextTitle variant="h5">Job Applied</TextTitle>
          <AppliedJobTable />
        </Grid>
      </RootGrid>
    </Box>
  );
}